interface SelectDetail {
  datePickers: Array<{
    label: string;
    name: string;
    placeHolder: string;
    min: string;
    max: string;
  }>;
  optionPickers: Array<{
    label: string;
    name: string;
    placeHolder: string;
    options: Array<string>;
  }>;
  rangePickers: Array<{
    label: string;
    name: string;
    placeHolder: string;
    range: Array<Array<number | string>>;
  }>;
}

type QcmDetail = Array<{
  text: string;
  index: number;
}>;
interface QuestionView {
  id: string;
  type: "qcm" | "select";
  title: string;
  detail: QcmDetail | SelectDetail;
  imgUrl: string;
  answer?: any;
}

interface QuizzView {
  id: string;
  name: string;
  intro: {
    imgUrl: string;
    title: string;
    description: string;
    targetUrl: string;
  };
  outro: {
    imgUrl: string;
    title: string;
    description: string;
    targetUrl: string;
  };
  questions: Array<QuestionView>;
  completionTargetUrl: string;
}

const defaultQuizzesView = new Map<string, QuizzView>();

export { QuestionView, QuizzView, defaultQuizzesView, SelectDetail };
